module.exports = __webpack_public_path__ + "img/ng.c2c7ea5b.svg";